import "./App.css";
import Header from "./components/Header.jsx";
import HeroSection from "./components/HeroSection.jsx";
import ServicesSection from "./components/ServicesSection.jsx";
import ExperienceSection from "./components/ExperienceSection.jsx";
import AboutSection from "./components/AboutSection.jsx";
import ContactSection from "./components/ContactSection.jsx";
import Footer from "./components/Footer.jsx";
import { useRevealOnScroll } from "./useReveal.js";
import {
  company,
  services,
  experienceHighlights,
  principles,
  team,
  contact,
  navigationLinks
} from "./content/siteContent.js";

function App() {
  useRevealOnScroll();

  return (
    <div className="app">
      <Header companyName={company.name} links={navigationLinks} />
      <main>
        <HeroSection company={company} />
        <ServicesSection items={services} />
        <ExperienceSection highlights={experienceHighlights} />
        <AboutSection principles={principles} team={team} />
        <ContactSection copy={contact} />
      </main>
      <Footer />
    </div>
  );
}

export default App;
